import { render, staticRenderFns } from "./script-pack-about.vue?vue&type=template&id=63faabb8&scoped=true&"
import script from "./script-pack-about.js?vue&type=script&lang=js&"
export * from "./script-pack-about.js?vue&type=script&lang=js&"
import style0 from "./script-pack-about.scss?vue&type=style&index=0&id=63faabb8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63faabb8",
  null
  
)

component.options.__file = "script-pack-about.vue"
export default component.exports